// Burger -----------------------------------------------------------------------------------------------------------------------
let menuBtn = document.querySelector('.menu-btn');
let menu = document.querySelector('.menu');
let menuLinks = document.querySelectorAll('.menu a');

menuBtn.addEventListener('click', function () {
  menuBtn.classList.toggle('active');
  menu.classList.toggle('active');

  if (menu.classList.contains('active')) {
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
  } else {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }
});
const toggleBtn = document.getElementById('toggleShop');
const dropdown = document.getElementById('shopList');
const chevron = document.getElementById('chevron');

toggleBtn.addEventListener('click', () => {
  dropdown.classList.toggle('max-h-0');
  chevron.classList.toggle('rotate-180');
});

// Mobile Search -----------------------------------------------------------------------------------------------------------------
const searchBtn = document.querySelector('.mob-search');
const searchOverlay = document.getElementById('mobile-search-overlay');
const searchBox = document.getElementById('mobile-search-box');
const body = document.body;

function openSearch() {
  searchOverlay.classList.remove('hidden');
  searchBox.classList.remove('hidden');
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden');
}

function closeSearch() {
  searchOverlay.classList.add('hidden');
  searchBox.classList.add('hidden');
  document.documentElement.classList.remove('overflow-hidden');
  document.body.classList.remove('overflow-hidden');
}

searchBtn.addEventListener('click', openSearch);
searchOverlay.addEventListener('click', closeSearch);
